import React from 'react'

import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

const iconPath = 'M16.5,7.11V43H12.28V7.11A2.11,2.11,0,0,1,16.5,7.11Zm2.11,2.11V30.33L39.72,19.78Z'

/**
 * Stateless function representing a map search icon.
 *
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <...Icon width={12} />
 */
const MapSearchIcon = props => (
    <SvgIcon {...props}>
        <path d={iconPath} />
    </SvgIcon>
)

MapSearchIcon.defaultProps = defaultProps

export { MapSearchIcon }
